import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
	selector: "caass-bus-history-selector-bus-results",
	templateUrl: "./bus-history-selector-bus-results.component.html",
	styleUrls: ["./bus-history-selector-bus-results.component.css"],
})
export class BusHistorySelectorBusResultsComponent implements OnInit {
	constructor() {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.UpdateData();
	}

	ngOnChanges() {
		this.UpdateData();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() TableLoading: any = false;
	@Output() SelectedChanged: EventEmitter<any> = new EventEmitter();

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedBuses: any = [];
	@Input() lstBus: any = [];

	//Filter lists
	lstActiveDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "BusNbr", header: "Bus Number" },
		{ field: "BusDesc", header: "Description" },
		{ field: "ActiveDesc", header: "Active" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	UpdateData() {
		this.SelectedBuses = [];
		this.lstActiveDesc = Array.from(new Set(this.lstBus.map((item: any) => item.ActiveDesc))).sort();
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onCheckClick() {
		this.SelectedChanged.emit(this.SelectedBuses);
	}
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedChanged.emit(this.SelectedBuses);
		// this.SelectedBus = val.data;
	}
	onRowUnselect(val) {
		this.SelectedChanged.emit(this.SelectedBuses);
		// this.SelectedBus = null;
	}
	onRowDblClick(Bus) {
		this.SelectedChanged.emit(this.SelectedBuses);
		// this.SelectedBus = Bus;
		// this.onEditBus();
	}
	////////////////////////////////////////////
}
